// Show the select for etablissements when checkbox is checked
//because contact form 7 conditional fields does not seems to work :'(

const checkboxEtab = document.querySelector('.checkbox-etab input');
const selectEtab = document.querySelector('.etab-select');

if (checkboxEtab) {

  checkboxEtab.addEventListener('change', e => {
    if(e.target.checked === true) {
      selectEtab.classList.add("show-select");
    }

    if(e.target.checked === false) {
      selectEtab.classList.remove("show-select");
    }
  });
}